import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton";
import ArgonEditor from "components/ArgonEditor";
import ArgonInput from "components/ArgonInput";
import ArgonSnackbar from "components/ArgonSnackbar";
import ArgonTypography from "components/ArgonTypography";
import SweetAlertCancel from "layouts/pages/sweet-alerts/components/WithSuccessAttachedFunction/CancelSomething";

export const SafeArgonBox = ArgonBox as any;
export const SafeArgonTypography = ArgonTypography as any;
export const SafeArgonButton = ArgonButton as any;
export const SafeArgonAvatar = ArgonAvatar as any;
export const SafeArgonInput = ArgonInput as any;
export const SafeArgonBadge = ArgonBadge as any;
export const SafeArgonSnackbar = ArgonSnackbar as any;
export const SafeSweetCancelAlert = SweetAlertCancel as any;
export const SafeArgonEditor = ArgonEditor as any;
